export default __webpack_public_path__ + "static/media/app.ab06aa4a.png";